import { z } from 'zod';
import { COMPONENTES_DE_INTERFAZ, DOCUMENTOS_EXISTENTES, TIPOS_DE_ESTUDIO, } from '../catalogos/componentes.js';
import { ESPECIALIDADES } from '../catalogos/especialidades.js';
import { MODULOS } from '../catalogos/modulos.js';
import { CODIGOS_DE_OBSERVACION } from '../catalogos/observaciones.js';
/**
 * Manifiesto de paquete de especialidad (F2.5, plan maestro §6.2).
 *
 * El manifiesto SELECCIONA de registros cerrados: modulos, componentes de
 * interfaz, tipos de estudio, observaciones, documentos existentes y
 * plantillas. No hay campo donde quepa codigo.
 */
export const ESTADOS_DE_PAQUETE = [
    'borrador',
    'en-revision-clinica',
    'validado-piloto',
    'validado',
    'retirado',
];
/** `cardiologia.consulta.v1`: plantilla y version exacta. */
export const PATRON_REFERENCIA_PLANTILLA = /^[a-z]+(?:-[a-z]+)*\.[a-z]+(?:-[a-z]+)*\.v[1-9]\d*$/;
export const esquemaManifiestoDePaquete = z
    .object({
    id: z.enum(ESPECIALIDADES),
    /** Semver del paquete. Cambia con cualquier cambio del manifiesto. */
    version: z.string().regex(/^\d+\.\d+\.\d+$/, 'Versión semántica (1.0.0)'),
    estado: z.enum(ESTADOS_DE_PAQUETE),
    nombre: z.string().trim().min(1).max(120),
    /** Modulos que tienen que estar habilitados para usar el paquete. */
    dependencias: z.array(z.enum(MODULOS)).max(MODULOS.length),
    plantillas: z.array(z.string().regex(PATRON_REFERENCIA_PLANTILLA)).max(50),
    documentosExistentes: z.array(z.enum(DOCUMENTOS_EXISTENTES)).default([]),
    observaciones: z.array(z.enum(CODIGOS_DE_OBSERVACION)).default([]),
    tiposEstudio: z.array(z.enum(TIPOS_DE_ESTUDIO)).default([]),
    componentes: z.array(z.enum(COMPONENTES_DE_INTERFAZ)).min(1),
    perfilPermisos: z.string().regex(/^[a-z]+(?:-[a-z]+)*\.v[1-9]\d*$/),
    /** Nada clinico se publica sin la firma de un profesional (plan §6.5). */
    requiereAprobacionClinica: z.literal(true),
})
    .strict();
//# sourceMappingURL=paquete.js.map